<template>
</template>

<script>
    import VueFormGenerator from "vue-form-generator/dist/vfg.js";

    Vue.use(VueFormGenerator);

    export default {

        props: ["model", "schema"],


        methods: {

            init: function () {

                this.model.business = false;

                this.model.business_data = {
                    name: "",
                    vat: "",
                    address: "",
                    postal_code: "",
                    city: "",
                };

                this.schema.groups.push({
                        fields: [
                            {
                                type: "customCheckbox",
                                label: "Račun na podjetje?",
                                model: "business",
                                listBox: true,
                                text: "Da, želim račun na podjetje",
                                hint: "V primeru, da želite račun na podjetje, obkljukajte to opcijo, saj naknadno spreminjanje računa ni mogoče.",
                                styleClasses: "col-sm-12",
                                visible: function(model) {
                                    return model.price_total > 0
                                }
                            },
                            {
                                type: "input",
                                inputType: "text",
                                label: "Naziv podjetja",
                                model: "business_data.name",
                                required: true,
                                validator: VueFormGenerator.validators.string,
                                styleClasses: 'col-sm-6',
                                visible(model) {
                                    return model.business
                                }
                            },
                            {
                                type: "input",
                                inputType: "text",
                                label: "Davčna številka",
                                model: "business_data.vat",
                                required: true,
                                validator: VueFormGenerator.validators.string,
                                styleClasses: 'col-sm-6',
                                visible(model) {
                                    return model.business
                                }
                            },
                            {
                                type: "input",
                                inputType: "text",
                                label: "Naslov podjetja",
                                model: "business_data.address",
                                required: true,
                                validator: VueFormGenerator.validators.string,
                                styleClasses: 'col-sm-12',
                                visible(model) {
                                    return model.business
                                }
                            },
                            {
                                type: "input",
                                inputType: "text",
                                label: "Poštna številka podjetja",
                                model: "business_data.postal_code",
                                required: true,
                                validator: VueFormGenerator.validators.string,
                                styleClasses: 'col-sm-6',
                                visible(model) {
                                    return model.business
                                }
                            },
                            {
                                type: "input",
                                inputType: "text",
                                label: "Kraj podjetja",
                                model: "business_data.city",
                                required: true,
                                validator: VueFormGenerator.validators.string,
                                styleClasses: 'col-sm-6',
                                visible(model) {
                                    return model.business
                                }
                            },
                        ]
                    }
                );
            }
        }

    };
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/modules/CustomerBusiness.vue